import { useCallback, useEffect, useState } from 'react'

function cloneSeed(seed) {
  return Array.isArray(seed) ? seed.map((item) => ({ ...item })) : []
}

export function readLocalCollection(key, seed = []) {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return cloneSeed(seed)
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : cloneSeed(seed)
  } catch {
    return cloneSeed(seed)
  }
}

export function useLocalCollection(key, seed = []) {
  const [items, setItems] = useState(() => readLocalCollection(key, seed))

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(items))
    } catch (error) {
      console.warn(`DIFAN admin local collection save failed: ${key}`, error)
    }
  }, [items, key])

  const upsert = useCallback((next) => {
    setItems((current) => {
      const index = current.findIndex((item) => item.id === next.id)
      if (index < 0) return [next, ...current]
      return current.map((item, itemIndex) => itemIndex === index ? { ...item, ...next } : item)
    })
  }, [])

  const remove = useCallback((id) => {
    setItems((current) => current.filter((item) => item.id !== id))
  }, [])

  const reset = useCallback(() => setItems(cloneSeed(seed)), [seed])

  return { items, setItems, upsert, remove, reset }
}
